export const SCREEN_CONTENT_CHANGED = 'SCREEN_CONTENT_CHANGED';
export const SCREEN_GROUP_CONTENT_CHANGED = 'SCREEN_GROUP_CONTENT_CHANGED';
